<template>
  <div class="spl-login">
    <main-header-login />
    <subheader-login />
    <recover-password-modal />
    <message-modal />
  </div>
</template>

<script>
export default {
  name: 'Login'
}
</script>

<style lang="scss">

</style>
